import { invert } from 'lodash';
import { PLATFORM_TYPES } from '../../constants/platforms';

export const CHECK_OWNERSHIP_URL = '/api/v1/{campaignId}/players/{userId}/ownership';
export const GET_PLAYER_INFO_URL = '/api/v1/{campaignId}/players/{userId}';
export const FRIEND_INVITEES_URL = '/api/v1/{campaignId}/players/{userId}/invitees';
export const REGISTER_PLAYER_URL = '/api/v1/{campaignId}/players/{userId}/{platformId}';
export const GET_CAMPAIGN_INFO_URL = '/api/v1/{campaignId}';
export const GET_INVITE_INFO_URL = '/api/v1/{campaignId}/players/{userId}/invite_info';
export const ACCEPT_INVITATION_URL = '/api/v1/{campaignId}/players/{userId}/accept_invite';
export const GET_REWARDS_INFO_URL = '/api/v1/{campaignId}/rewards';
export const GET_CAMPAIGN_STATUS_URL = '/api/v1/{campaignId}/status';
export const GET_PLAYERS_OWNERSHIP_URL = '/api/v1/{campaignId}/players/ownership';
export const GET_PLAYERS_URL = '/api/v1/{campaignId}/players';

export enum GRANT_TYPES {
    BOTH = 'both',
    REFERRER = 'referrer',
    INVITEE = 'invitee',
}

export const GRANT_TYPES_ID: { readonly [key: string]: number } = {
    [GRANT_TYPES.BOTH]: 1,
    [GRANT_TYPES.REFERRER]: 2,
    [GRANT_TYPES.INVITEE]: 3,
};

export enum ERROR_TYPE {
    NETWORK_ERROR,
    API_ERROR
}

export const PLAYER_ERRORS_CODES = {
    PLAYER_IS_NOT_REGISTERED: 2004
};

export const PLATFORM_TO_REFERRAL_PLATFORM_ID: { readonly [key: string]: number } = {
    [PLATFORM_TYPES.PC]: 1,
    [PLATFORM_TYPES.PS4]: 2,
    [PLATFORM_TYPES.XONE]: 3,
    [PLATFORM_TYPES.PS5]: 4,
    [PLATFORM_TYPES.XSX]: 5,
    [PLATFORM_TYPES.SWITCH]: 6,
    [PLATFORM_TYPES.STADIA]: 7
};

export const REFERRAL_PLATFORM_ID_TO_PLATFORM
    = invert(PLATFORM_TO_REFERRAL_PLATFORM_ID) as { readonly [key: string]: PLATFORM_TYPES };
